import { render, staticRenderFns } from "./LatestUpdateTime.vue?vue&type=template&id=c3668b74&"
import script from "./LatestUpdateTime.vue?vue&type=script&lang=js&"
export * from "./LatestUpdateTime.vue?vue&type=script&lang=js&"
import style0 from "./LatestUpdateTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports